import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  ADD_UPDATE_USER_REQUEST,
  ADD_UPDATE_USER_SUCCESS,
  ADD_UPDATE_USER_FAILURE,
  SET_LOGGED_IN_USER_REQUEST,
} from "./actionTypes";
import { UsersState } from "./types";

const initialState: UsersState = {
  users: [],
  loadingScreen: false,
  error: null,
  totalCount: 0,
  successMessage: "",
  userInfo: null,
  pending: false
};

const usersReducer = (state = initialState, action: any): UsersState => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loadingScreen: true,
        error: null,
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        users: action.payload.users,
        totalCount: action.payload.totalCount,
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };

    case ADD_UPDATE_USER_REQUEST:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case ADD_UPDATE_USER_SUCCESS:
      return {
        ...state,
        pending: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_USER_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    case SET_LOGGED_IN_USER_REQUEST:
      return {
        ...state,
        userInfo: action.payload,
      };

    default:
      return state;
  }
};

export default usersReducer;
